/** @file PadletHalfEllipseShape schema */
import { defaultColorNames, T, TLBaseShape, TLDefaultColorStyle, TLDefaultFillStyle } from 'tldraw'

const padletHalfEllipseShapeProps = {
  w: T.number,
  h: T.number,
  fill: T.literalEnum('none', 'fill', 'pattern', 'semi', 'solid'),
  color: T.literalEnum(...defaultColorNames),
}

interface PadletHalfEllipseShapeProps {
  w: number
  h: number
  fill: TLDefaultFillStyle
  color: TLDefaultColorStyle
}

type PadletHalfEllipseShape = TLBaseShape<'padlet-half-ellipse', PadletHalfEllipseShapeProps>

export { PadletHalfEllipseShape, PadletHalfEllipseShapeProps, padletHalfEllipseShapeProps }
